import React from 'react';
import { Chip, Typography, Stack, Grid } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { useNavigate } from 'react-router';

export default function PaymentTable(props) {
  const Navigate = useNavigate();
  const Datatable = props.ResData;

  function formatDateTime(dateString) {
    const date = new Date(dateString);

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;

    return `${formattedDate}`;
  }

  return (
    <div>
      {Datatable.length > 0 ? (
        <Paper sx={{ width: '100%' }}>
          <TableContainer sx={{ maxHeight: 500, width: 1100 }}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: 80, color: '#592375' }}>Agent Name</TableCell>
                  <TableCell sx={{ width: 80, color: '#592375' }}>Agent Code</TableCell>
                  <TableCell sx={{ width: 80, color: '#592375' }}>CSP Code</TableCell>
                  <TableCell sx={{ width: 80, color: '#592375' }}>Bank Name</TableCell>
                  <TableCell sx={{ width: 100, color: '#592375' }}>CSP Activation Date</TableCell>
                  <TableCell sx={{ width: 80, color: '#592375' }}>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Datatable &&
                  Datatable
                    // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      return (
                        <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                          <TableCell>{row.agent_name ? row.agent_name : '-'}</TableCell>
                          <TableCell>{row.agent_code ? row.agent_code : '-'}</TableCell>
                          <TableCell sx={{ alignItems: 'center' }}>{row.csp_code}</TableCell>
                          <TableCell>{row.bank_name}</TableCell>
                          <TableCell>{formatDateTime(row.csp_code_activation_date)}</TableCell>
                          <TableCell sx={{ cursor: 'pointer', alignItems: 'center' }}>
                            <Chip
                              label="Create terminal id +"
                              color="primary"
                              onClick={() =>
                                Navigate('/Admin/Terminal_mapping_details', {
                                  state: {
                                    type: 'create',
                                    id: row._id,
                                    code: row.csp_code
                                  }
                                })
                              }
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            sx={{ width: '100%' }}
            rowsPerPageOptions={[10, 50, 100]}
            component="div"
            count={props.TotalCount}
            rowsPerPage={props.rowsPerPage}
            page={props.page}
            onPageChange={props.handleChangePage}
            onRowsPerPageChange={props.handleChangeRowsPerPage}
          />
        </Paper>
      ) : (
        <Grid item xl={12} mt={5}>
          <Stack justifyContent="center" alignItems="center">
            <Typography mt={1} variant="h5">
              No data found
            </Typography>
          </Stack>
        </Grid>
      )}
    </div>
  );
}
